interface MetaAdsAccountLike {
  account_name?: string;
  currency?: string;
}

export const getAdAccountLabel = (
  adAccountId: string | number,
  adsAccounts: Record<string, MetaAdsAccountLike> | null | undefined,
) => adsAccounts?.[adAccountId]?.account_name ?? `Ad Account ID: ${adAccountId}`;

/**
 * Returns the currency of the first Meta Ads account. Accepts either a record keyed by account id
 * or an array of accounts.
 */
export function getCurrencyFromMetaAdsAccounts(
  metaAdsAccounts: Record<string, MetaAdsAccountLike> | MetaAdsAccountLike[] | null | undefined,
): string | undefined {
  return Object.values(metaAdsAccounts ?? {})[0]?.currency;
}
